"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const circleNameVertex_1 = require("../../node/circleNameVertex");
const iGraph_1 = require("../../../lib/interactive/iGraph");
const graphGrid_1 = require("../../../lib/graph/graphGrid");
const simpleDirectedWeightedEdge_1 = require("../../edge/simpleDirectedWeightedEdge");
class SimpleInteractiveDirectedGraph extends iGraph_1.IGraph {
    constructor(canvas) {
        super(iGraph_1.GraphType.DIRECTED_GRAPH, new graphGrid_1.GraphGrid(canvas), canvas);
    }
    newNode(args) {
        if (args == undefined || args.length == 0)
            return new circleNameVertex_1.CircleNameVertex();
        return new circleNameVertex_1.CircleNameVertex(args[0]);
    }
    newEdge(from, to, args) {
        return new simpleDirectedWeightedEdge_1.SimpleDirectedWeightedEdge(from, to);
    }
    doubleClick(e) { }
    keyBoardEvent(k) {
    }
}
exports.SimpleInteractiveDirectedGraph = SimpleInteractiveDirectedGraph;
